"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Binding_1 = require("./Binding");
var Binding_2 = require("./Binding");
exports.Binding = Binding_2.Binding;
class CopyOnWriteArray extends Array {
    get length() { return super.length; }
    toString() { return super.toString.call(Binding_1.R(this)); }
    toLocaleString() { return super.toLocaleString.call(Binding_1.R(this)); }
    pop() { return super.pop.call(Binding_1.W(this)); }
    push(...items) { return super.push.call(Binding_1.W(this), ...items); }
    concat(...items) { return super.concat.call(Binding_1.R(this), ...items); }
    join(separator) { return super.join.call(Binding_1.R(this), separator); }
    reverse() { return super.reverse.call(Binding_1.R(this)); }
    shift() { return super.shift.call(Binding_1.R(this)); }
    slice(start, end) { return super.slice.call(Binding_1.R(this), start, end); }
    sort(compareFn) { super.sort.call(Binding_1.W(this), compareFn); return this; }
    splice(start, deleteCount, ...items) { return super.splice.call(Binding_1.W(this), start, deleteCount, ...items); }
    unshift(...items) { return super.unshift.call(Binding_1.W(this), ...items); }
    indexOf(searchElement, fromIndex) { return super.indexOf.call(Binding_1.R(this), searchElement, fromIndex); }
    lastIndexOf(searchElement, fromIndex) { return super.lastIndexOf.call(Binding_1.R(this), searchElement, fromIndex); }
    every(callbackfn, thisArg) { return super.every.call(Binding_1.R(this), callbackfn, thisArg); }
    some(callbackfn, thisArg) { return super.some.call(Binding_1.R(this), callbackfn, thisArg); }
    forEach(callbackfn, thisArg) { return super.forEach.call(Binding_1.R(this), callbackfn, thisArg); }
    map(callbackfn, thisArg) { return super.map.call(Binding_1.R(this), callbackfn, thisArg); }
    filter(callbackfn, thisArg) { return super.filter.call(Binding_1.R(this), callbackfn, thisArg); }
    // reduce(callbackfn: (previousValue: T, currentValue: T, currentIndex: number, array: T[]) => T, initialValue?: T): T;
    // reduce<U>(callbackfn: (previousValue: U, currentValue: T, currentIndex: number, array: T[]) => U, initialValue: U): U { return super.reduce.call(R<T[]>(this), callbackfn, initialValue); }
    // reduceRight(callbackfn: (previousValue: T, currentValue: T, currentIndex: number, array: T[]) => T, initialValue?: T): T;
    // reduceRight<U>(callbackfn: (previousValue: U, currentValue: T, currentIndex: number, array: T[]) => U, initialValue: U): U { return super.reduceRight.call(R<T[]>(this), callbackfn, initialValue); }
    static seal(owner, prop, array) {
        return Binding_1.Binding.seal(owner, prop, array, CopyOnWriteArray.prototype, CopyOnWriteArray.clone);
    }
    static clone(array) {
        return Array.prototype.slice.call(array);
    }
}
exports.CopyOnWriteArray = CopyOnWriteArray;
